import { useKitData } from "@/data/use-kits-data";
import { useSkillData } from "@/data/use-skill-data";
import { useSkillsData } from "@/data/use-skills-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { Kit } from "@/types/types";
import { KitQuickSettingsUI } from "./KitQuickSettingsUI";

type SkillKitQuickSettingsProps = {
  kit: Kit;
};

export const SkillKitQuickSettings = ({ kit }: SkillKitQuickSettingsProps) => {
  const groupUuid = useGroupUuid();
  const { updateKit } = useKitData(groupUuid, kit.uuid);
  const { skills } = useSkillsData(groupUuid, kit.uuid);
  const skillUuid = skills[0]?.uuid;
  const { updateSkill } = useSkillData(groupUuid, kit.uuid, skillUuid);

  return (
    <KitQuickSettingsUI
      kit={kit}
      onNameChange={async (name) => {
        const result = await updateKit({ name });
        if (!result.error && skillUuid) await updateSkill({ name });
        return result;
      }}
    />
  );
};
